/**
 * This helper contains everything used to search in algolia. 
 */
 import algoliasearch from 'algoliasearch';

 // Starting the Algolia Index
 const AlgoliaClient = algoliasearch(
     process.env.ALGOLIA_APP_ID,
     process.env.ALGOLIA_SEARCH_ID
);
 const AlgoliaIndex = AlgoliaClient.initIndex(process.env.ALGOLIA_INDEX); 

 const Searcher = {
    search: (query, params = {}) => {
        // This method should probably loop through all results so we get everything we need 
        return AlgoliaIndex.search(query, params); 
    }, 

    searchFacet: (facetName, facetQuery, params) => {
        return AlgoliaIndex.searchForFacetValues(facetName, facetQuery, params); 
    }, 

    /**
     * Checks if a value is a valid, non-empty filter value.
     * Guards against JavaScript null, empty strings, and the literal string "null"
     * (which can appear when bots/crawlers hit URLs with ?year=null&make=null).
     */
    isValidFilterValue: (value) => {
        return value != null && value !== '' && value !== 'null';
    },

    /**
     * This method builds the filters to make the new search. 
     */
    buildFilters: (values) => {
        let filters = ['active:true']; 
        
        if ( Searcher.isValidFilterValue(values.year) ) {
            filters.push(`vehicle.start_year<=${values.year} AND vehicle.end_year>=${values.year}`); 
        }

        if ( Searcher.isValidFilterValue(values.make) ) {
            filters.push(`vehicle.make:'${values.make}'`); 
        }

        if ( Searcher.isValidFilterValue(values.model) ) {
            filters.push(`vehicle.model:'${values.model}'`); 
        }

        if ( Searcher.isValidFilterValue(values.submodel) ) {
            filters.push(`vehicle.submodel:'${values.submodel}'`); 
        }

        return filters.join(' AND '); 
    },

    searchAll: async (query, params = {}) => {
        let hits = [];

        // Get all records
        await AlgoliaIndex.browseObjects({
            query: query,
            ...params,
            batch: batch => {
                hits = hits.concat(batch);
            }
        });

        return hits;
    }
 }

 export default Searcher; 